import React from 'react'
import MuiAccordion, { AccordionProps } from '@material-ui/core/Accordion'
import MuiAccordionSummary, { AccordionSummaryProps } from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails, { AccordionDetailsProps } from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import styles from './accordion.module.scss'

import cx from 'classnames'

type AccordionSummaryType = React.FC<AccordionSummaryProps>
type AccordionDetailsType = React.FC<AccordionDetailsProps>

interface AccordionType extends React.FC<AccordionProps> {
  Summary: AccordionSummaryType
  Details: AccordionDetailsType
}

export const Accordion: AccordionType = ({ classes, ...props }) => (
  <MuiAccordion
    elevation={0}
    classes={{ ...classes, root: cx(styles.accordion, classes?.root) }}
    {...props}
  />
)

export const AccordionSummary: AccordionSummaryType = ({ classes, ...props }) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon />}
    classes={{ ...classes, root: cx(styles.accordionSummary, classes?.root) }}
    {...props}
  />
)

export const AccordionDetails: AccordionDetailsType = ({ classes, ...props }) => (
  <MuiAccordionDetails
    classes={{ ...classes, root: cx(styles.accordionDetails, classes?.root) }}
    {...props}
  />
)

Accordion.Summary = AccordionSummary
Accordion.Details = AccordionDetails

export default Accordion
